import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { MbIconText, MbIcon } from '@am/moebius';
import { NgIf } from '@angular/common';

@Component({
    selector: 'am-disney-combos',
    templateUrl: './disney-combos.component.html',
    styleUrls: ['./disney-combos.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: true,
    imports: [
        NgIf,
        MbIconText,
        MbIcon,
    ],
})
export class DisneyCombosComponent {
  @Input()
  public hasRoomOnlyOption = false;

  @Input()
  public hasTickets = false;

  @Input()
  public hasMealPlan = false;

  @Input()
  public isFreeMealPlan: boolean = false;

  constructor() {}
}
